export const inServer = process.env.BUILD_TARGET === 'server';
export const SERVER_RENDER_BREAKPOINT = '__SERVER_RENDER_BREAKPOINT__';
export const COOKIE_FAVORITES = 'kvanum-favorites';
export const COOKIE_CONSENT = 'kvanum-consent';
export const DEFAULT_CONTACT_EMAIL = 'marknad@kvanum.com';
export const DEFAULT_SUPPORT_SERVICE_EMAIL = 'kundservice@kvanum.com';
const EMAIL_ENDPOINT = 'https://hde586em3h.execute-api.eu-north-1.amazonaws.com';

// Use QA-prefixed Lambda functions for all non-production environments
const isProduction = process.env.GATSBY_APP_ENV === 'production';
export const UPLOAD_FILE_URL = `${EMAIL_ENDPOINT}/${isProduction ? 'uploadFile' : 'qaUploadFile'}`;
export const SEND_EMAIL_URL = `${EMAIL_ENDPOINT}/${isProduction ? 'sendEmail' : 'qaSendEmail'}`;